import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { colors } from "@utils/styles";
import ButtonGroup from "components/Reusables/ButtonGroup";
import ConditionalWrapper from "components/Reusables/ConditionalWrapper";
import Text from "components/Reusables/Text";
import Spinner from "react-bootstrap/Spinner";

export default function SocialShareButton(props) {
	const {
		icon,
		text,
		smOrSmaller,
		link = false,
		onClick = () => {},
		loading = false,
		disabled,
		className = "",
		gtmEvent = () => {},
	} = props;

	return (
		<div className={className}>
			<ConditionalWrapper
				condition={link}
				wrapper={(children) => (
					<a
						className="social-share"
						onClick={() => {
							window.open(link, "popup", "width=600,height=600");
						}}
					>
						{children}
					</a>
				)}
			>
				<ButtonGroup
					isDisabled={disabled}
					buttonWidth={{ xs: "" }}
					groupClasses={`mb-2 w-100 ${disabled ? " look-disabled " : " "} ${className}`}
					title={disabled ? " Please log in to use this feature " : " "}
					outlineColor={colors.greyBlue}
					additionalClasses={`pt-2 d-inline-block bg-white`}
					button1Variant="transparent"
					// btn1={{ url: "#" }}
					onClick={() => {
						onClick();
						gtmEvent();
					}}
					button1Children={
						<div>
							{loading && (
								<Spinner variant="primary" animation="border" role="status" aria-hidden="true" />
							)}
							{!loading && (
								<FontAwesomeIcon
									width={smOrSmaller ? "1.2em" : "1.5em"}
									height={smOrSmaller ? "1.2em" : "1.5em"}
									color={colors.greyBlue}
									icon={icon}
								/>
							)}

							<Text display="block" size="11" marginBottom={0} text={text} />
						</div>
					}
				/>
				<style global jsx>{`
					.spinner-border.text-primary {
						color: ${colors.green} !important;
						width: ${smOrSmaller ? "1.2em" : "1.5em"};
						height: ${smOrSmaller ? "1.2em" : "1.5em"};
					}
				`}</style>
			</ConditionalWrapper>
		</div>
	);
}
